











export default {
    name: 'BaseSortIcons',
    components: {},
    props: {
        order_param: String,
    },
    data() {
        return {};
    },
    methods: {
        submit(sortParam) {
            this.$store.dispatch('setOrderParam', this.order_param);
            this.$store.dispatch('setSortParam', sortParam);
            this.$emit('sort');
        },
    },
};
